import { useTranslation } from 'react-i18next'

import { useCheckinPending } from './useCheckinPending'

/**
 * «2 fitxatges pendents d'enviar.»
 *
 * El punt ambre pulsant que la porta i les idees ja fan servir, ara per al
 * membre. Sense això, la cua només es veia dins del bloc de fitxatge i mentre
 * no en sorties: tancaves l'app a la festa, l'obries l'endemà, i no en quedava
 * cap rastre —ni de la cua, ni que els punts encara no eren teus.
 *
 * Desapareix quan la cua és buida, i per tant no diu res els 364 dies que no
 * hi ha res a dir.
 */

export function PendingLine({ className = '' }: { readonly className?: string }) {
  const { t } = useTranslation()
  const { queued, online } = useCheckinPending()

  if (queued === 0) return null

  return (
    // Sense `role="status"`, i el criteri és el que el `Notice` deixa escrit:
    // s'anuncia el que entra sol, no el que ja hi era. A l'Inici això viu dins
    // la capçalera i hi és des que la pantalla carrega; qui apareix sol quan
    // cau la connexió és el rètol de sobre, i és el que parla. Amb tots dos
    // dient-ho, obrir l'app sense cobertura eren dos anuncis veïns.
    <p
      className={
        'flex items-center gap-3 text-sm font-bold text-[var(--ds-warning-deep)] ' + className
      }
    >
      <span
        aria-hidden="true"
        className="size-[8px] flex-none animate-pulse rounded-full bg-[var(--ds-warning-deep)]"
      />
      {online
        ? t('checkin.pending', { count: queued })
        : t('checkin.pendingOffline', { count: queued })}
    </p>
  )
}
